import React from 'react';
import styled from 'styled-components';

import {
  AdornedInput,
  Adornment,
  FieldSet,
  Label,
  LabeledControl,
  Legend,
  Paragraph,
  Radio,
  spaceMixin,
} from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import { CURRENCY_INPUT_PLACEHOLDER } from '../../../../constants/stringConstants';

const ShiftedChild = styled.div`
  margin-left: ${spaceMixin('lg')};
`;

export const REGION1 = 'REGION1';
export const REGION2 = 'REGION2';

type Props = {
  fixedAmountSelected: boolean;
  fixedAmountValue: number;
  setFixedAmountSelected: () => void;
  setFixedAmountValue: (event: Event) => void;
  setVariableMonthlySelected?: () => void;
  variableMonthlyCostSelected?: boolean;
  noAdditionalFee?: boolean;
  noAdditionalFeeSelected?: boolean;
  setAdditionalFeeSelected?: () => void;
  legendText: string;
};

export default function FixedOrVariableSelector({
  fixedAmountSelected,
  fixedAmountValue,
  setFixedAmountSelected,
  setFixedAmountValue,
  setVariableMonthlySelected,
  variableMonthlyCostSelected,
  noAdditionalFee,
  noAdditionalFeeSelected,
  setAdditionalFeeSelected,
  legendText,
}: Props): JSX.Element {
  return (
    <FieldSet legend={<Legend>{legendText}</Legend>}>
      <LabeledControl
        controlId="LabeledControl-fixed-amount"
        label={<Label>Fixed amount</Label>}
        size="lg"
        control={
          <Radio
            aria-label="Fixed amount"
            name="additional-fee"
            checked={fixedAmountSelected}
            onChange={setFixedAmountSelected}
          />
        }
      />
      <ShiftedChild data-test={REGION1} onClick={setFixedAmountSelected}>
        <AdornedInput
          inputId="AdornedInput-fixed-amount-value"
          leftAdornment={<Adornment>$</Adornment>}
          rightAdornment={<Adornment>per month</Adornment>}
          input={
            <CurrencyInput
              aria-label="fixed amount"
              data-test="fixedAmountValue"
              placeholder={CURRENCY_INPUT_PLACEHOLDER}
              value={fixedAmountValue || ''}
              onBlur={setFixedAmountValue}
              onChange={setFixedAmountValue}
            />
          }
        />
      </ShiftedChild>
      {noAdditionalFee ? (
        <LabeledControl
          controlId="LabeledControl-no-additional-fee"
          label={<Label>No additional fee for landscaping</Label>}
          size="lg"
          control={
            <Radio
              aria-label="No additional fee for landscaping"
              name="additional-fee"
              checked={noAdditionalFeeSelected}
              onChange={setAdditionalFeeSelected}
            />
          }
        />
      ) : (
        <LabeledControl
          controlId="LabeledControl-variable-month-cost"
          label={
            <Label>
              Variable monthly cost
              <Paragraph>Landlord determines reasonable proportion of actual cost</Paragraph>
            </Label>
          }
          size="lg"
          control={
            <Radio
              aria-label="Variable monthly cost"
              data-test={REGION2}
              name="additional-fee"
              checked={variableMonthlyCostSelected}
              onChange={setVariableMonthlySelected}
            />
          }
        />
      )}
    </FieldSet>
  );
}
